import type { SiteContent } from "../siteData";

type FooterProps = {
  footer: SiteContent["footer"];
};

export function Footer({ footer }: FooterProps) {
  return (
    <footer className="footer">
      <div className="container">
        <p>{footer.copyright}</p>
      </div>
    </footer>
  );
}
